export interface SetCookieParameters {
  name: string;
  value: string;
  path?: string;
  domain?: string;
  maxAge?: number;
}
/**
 * Sets a cookie with a default path of '/'. Note, this does not currently include every cookie option
 *
 * ```ts
 * setCookie({ name: 'cookiename', value: 'cookievalue', })
 * ```
 * @packageDocumentation
 */
export const setCookie = ({
  name,
  value,
  path = '/',
  domain = window.location.hostname,
  maxAge,
}: SetCookieParameters) => {
  let cookieText = `${name}=${value};path=${path};domain=${domain}`;
  if (maxAge !== undefined) {
    cookieText += `;max-age=${maxAge}`;
  }
  document.cookie = cookieText;
};

export interface GetCookieParameters {
  name: string;
}
/**
 * Gets a cookie value based on the name
 *
 * ```ts
 * setCookie({ name: 'pet', value: 'cat', })
 * const cookieValue = getCookie({ name: 'pet' });
 * // cookieValue equals cat
 * ```
 * @packageDocumentation
 */
export const getCookie = ({ name }: GetCookieParameters) => {
  const value = document.cookie.match(`(^|;) ?${name}=([^;]*)(;|$)`);
  return value ? value[2] : null;
};

export function deleteCookie(cookieName: string) {
  document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
}
